import script from "./ContextMenuIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContextMenuIcon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__